import React from "react";
import "./InitialLoader.css";

const InitialLoader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-text">MohanKumar .V V</div>
    </div>
  );
};

export default InitialLoader;
